export default __webpack_public_path__ + "static/media/os-upgrades-downgrades.ba3a650f.jpg";